import { createMultiStyleConfigHelpers, SystemStyleObject } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

export const parts = [
  'container',
  'icon',
  'content',
  'rightContent',
  'item',
  'tagEdit',
  'tagClear',
  'form',
  'formHeader',
  'formTitle',
  'formBadge',
  'formSearch',
  'formInputGroup',
  'formButtonGroup',
  'searchInput',
] as const;
export type FilterStyle = Record<(typeof parts)[number], SystemStyleObject>;

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts);

const disabledState = { background: 'transparent', borderColor: 'transparent', color: 'neutral.70' };

const FilterTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      background: 'neutral.100',
      display: 'flex',
      flexDirection: ['column', 'row'],
      gap: '12',
    },
    content: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12',
    },
    form: {
      background: 'neutral.100',
      borderRadius: '8',
      maxWidth: rem(480),
      minWidth: rem(352),
      padding: '16',
    },
    formBadge: {
      fontVariantNumeric: 'tabular-nums',
    },
    formButtonGroup: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBlockStart: '24',
    },
    formHeader: {
      display: 'flex',
      gap: '8',
      justifyContent: 'space-between',
      marginBlockEnd: '8',
    },
    formInputGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12',
      maxHeight: rem(196),
      overflowY: 'scroll',
      paddingBlock: rem(3),
      paddingInline: '12',
    },
    formSearch: {
      marginBlockEnd: '16',
    },
    formTitle: {
      color: 'purpe.10',
      fontWeight: 'semibold',
    },
    icon: {
      color: 'neutral.60',
      margin: '4',
    },
    item: {
      background: 'neutral.100',
      border: '1px solid',
      borderColor: 'neutral.80',
      borderRadius: '4',
      display: 'flex',
      width: 'fit-content',
      wordBreak: 'break-word',
    },
    rightContent: {
      display: 'flex',
      gap: '16',
      marginInlineStart: 'auto',
    },
    searchInput: {
      _focusVisible: {
        backgroundColor: 'neutral.95',
      },
      _hover: {
        backgroundColor: 'neutral.95',
      },
      border: undefined,
      borderColor: undefined,
      borderRadius: '4',
      boxShadow: undefined,
      fontSize: '2',
      paddingLeft: '32',
      paddingRight: '8',
      paddingY: '4',
    },
    tagClear: {
      _active: {
        background: 'neutral.90',
      },
      _disabled: {
        cursor: 'not-allowed',
        ...disabledState,
        _active: disabledState,
        _hover: disabledState,
      },
      _hover: {
        background: 'neutral.93',
      },
      border: 0,
      borderRadius: '4',
      color: 'purple.10',
      height: rem(30),
      justifyContent: 'flex-start',
      minWidth: rem(27),
      svg: {
        marginInlineStart: '4',
      },
    },
    tagEdit: {
      _active: {
        background: 'neutral.90',
      },
      _disabled: {
        cursor: 'not-allowed',
        ...disabledState,
        _active: disabledState,
        _hover: disabledState,
      },
      _hover: {
        background: 'neutral.93',
      },
      alignItems: 'center',
      borderRadius: '4',
      color: 'purple.10',
      display: 'flex',
      gap: '8',
      paddingBlock: '4',
      paddingInlineEnd: rem(7),
      paddingInlineStart: rem(11),
    },
  },
});

export default FilterTheme;
